import {useActions, useGetters, useMutators, useState} from './_default.js';
import axios from "axios";

export default {
    namespaced: true,
    state: {
        ...useState(),
        mapObjectsLoadUrl: '/payload/paginated/map/route',
        listUrl: '/payload/paginated/sidebar/route',
        params: { grouped: 1 },
    },
    getters: {
        ...useGetters(),
        defaultData: state => state.defaultData,
    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
        changeActive({ state}, data) {
            return new Promise((resolve, reject) => {
                return axios.put('/route/change-active', data).then((response) => {
                    resolve(response?.data);
                }).catch((error) => {
                    reject(error);
                })
            });
        },
    },
}
